export enum ImageFormat {
  Png = 'png',
  Jpeg = 'jpeg'
}

export enum SvgNamespace {
  Svg = 'http://www.w3.org/2000/svg',
  XLink = 'http://www.w3.org/1999/xlink'
}
